<template>
  <div style="margin-top:30px">
    <el-form ref="form" :rules="rules" :model="form" label-width="80px">
      <el-form-item label="编码" prop="code" style="margin-right:15px">
        <el-input v-model="form.code" placeholder="请输入编码" />
      </el-form-item>
      <el-form-item label="状态" prop="status" style="margin-right:15px">
        <compStatus ref="palletStatus" @queryStatus="selectStatus" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="funcCancel">
        取 消
      </el-button>
      <el-button type="primary" @click="funcSubmit">
        确 定
      </el-button>
    </div>
  </div>
</template>
<script>
import request from "@/utils/request";

import compStatus from "./palletStatus.vue";
export default {
  name: "PalletAdd",
  components: {
    compStatus,
  },
  data() {
    return {
      form: {
        code: "",
        status: "",
      },
      rules: {
        code: [{ required: true, message: "请输入编码", trigger: "blur" }],
        status: [
          {
            required: true,
            message: "请输入状态：0闲置,1使用",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {},
  methods: {
    selectStatus(value) {
      this.form.status = value;
    },
    // 提交
    funcSubmit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          const data = this.form;
          const rLoading = this.openLoading();
          request({
            url: "/ntocc-basic-api/pallet",
            method: "post",
            params: data,
          })
            .then((response) => {
              rLoading.close();
              this.$message({ message: response.msg, type: "success" });
              this.$emit("fatherAddMethod");
            })
            .then(() => this.$refs["form"].resetFields());
        } else {
          return false;
        }
      });
    },
    // 取消
    funcCancel() {
      this.$emit("fatherCancelMethod", "add");
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-footer {
  margin: 15px 0 15px 0;
  width: 175px;
  float: right;
}
</style>
